export enum UserRole {
  User = 0,
  Moderator = 1,
  Tenantadmin = 2,
  Pos = 3,
  Admin = 4,
}
